import React, { useEffect, useState } from "react";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";
import Banner from "../becomesell/Banner";
import { TiLocation } from "react-icons/ti";
import { FaMobile } from "react-icons/fa";
import { FaMessage } from "react-icons/fa6";
import { TbWorldSearch } from "react-icons/tb";
import PostBox from "../SellProfile/PostBox";
import ShopCardList from "./ShopCardList";
import EditProfile from "../SellProfile/EditProfile";
import PostList from "./PostList";
import axios from "axios";
import { useLocation } from "react-router-dom";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const Buyer = () => {
  const [tabs, setTabs] = useState(1);
  const [profiledate, setProfiledate] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [posts, setPosts] = useState([]);
  const location = useLocation();

  // 🔹 get sellerId from URL
  const queryParams = new URLSearchParams(location.search);
  const sellerId = queryParams.get("sellerId");

  const tabslist = [
    {
      id: 1,
      name: "Posts",
    },
    {
      id: 2,
      name: "About",
    },
    {
      id: 3,
      name: "Shop",
    },
  ];

  // 🔹 Fetch seller profile
  useEffect(() => {
    const fetchSellerProfile = async () => {
      if (!sellerId) {
        setError("Seller ID not provided in URL.");
        return;
      }

      try {
        setLoading(true);
        const token =
          sessionStorage.getItem("accessToken") ||
          localStorage.getItem("accessToken");

        if (!token) {
          setError("Authentication token missing. Please log in.");
          setLoading(false);
          return;
        }

        const res = await axios.get(
          `${API_BASE_URL}/buyer/get-seller-profile?seller_id=${sellerId}`,
          {
            headers: {
              token,
              "Content-Type": "application/json",
            },
          }
        );

        if (res?.data?.success) {
          setProfiledate(res.data.result);
        } else {
          setError(res?.data?.message || "Failed to load seller profile");
        }
      } catch (err) {
        console.error("Error fetching seller profile:", err);
        setError("Error fetching seller profile");
      } finally {
        setLoading(false);
      }
    };

    fetchSellerProfile();
  }, [sellerId]);

  // 🔹 Existing posts fetching logic stays the same
  // (since it depends on profiledate.id)
  useEffect(() => {
    if (profiledate?.id) {
      setPosts([]);
      setPage(1);
      setHasMore(true);
      fetchSellerPosts();
    }
  }, [profiledate]);
  const fetchSellerPosts = async () => {
    if (loading || !hasMore) return; // prevent duplicate calls
    if (!profiledate?.id) return; // wait until seller profile is loaded

    setLoading(true);
    setError(null);

    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");
    if (!token) {
      setError("Authentication token is missing. Please log in again.");
      setLoading(false);
      return;
    }

    const requestBody = {
      filters: {
        seller_id: Number(profiledate.id),
        is_seller_post: true, // ✅ enforce seller post only
      }, // ✅ seller_id as string
      page,
      limit: 10,
    };

    try {
      const response = await fetch(
        `${API_BASE_URL}/post/get-posts`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify(requestBody),
        }
      );

      const data = await response.json();

      if (response.ok && data.success) {
        const newPosts = data.result.posts;

        setPosts((prev) => {
          const existingIds = new Set(prev.map((p) => p.id));
          const filtered = newPosts.filter((p) => !existingIds.has(p.id));
          return [...prev, ...filtered];
        });

        setHasMore(newPosts.length === 10); // load more if full page returned
        setPage((prev) => prev + 1);
      } else {
        setError(data.message || "Failed to fetch posts.");
      }
    } catch (err) {
      console.error("❌ Error fetching posts:", err);
      setError("An error occurred while fetching posts.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (profiledate?.id) {
      setPosts([]); // reset posts
      setPage(1);
      setHasMore(true);
      fetchSellerPosts();
    }
  }, [profiledate]);

  return (
    <div className="dashboard w-full min-h-screen  flex">
      <Leftsidebar />
      <main className="flex-1 min-w-0 p-4 md:p-6 md:pl-8">
        <LeftResponsivesidebar />
        <Headmenu />

        <main className="">
          <div>
            <div>
              <Banner profiledate={profiledate} />
            </div>

            <div className="flex flex-col md:flex-row mt-6 sm:mt-20 w-[100%] gap-6 md:gap-10 ">
              <div className="w-full md:w-[70%] ">
                <div className="space-y-4 bg-gradient-to-r from-[#9cc5d4] to-[#a2e7c8] p-4 rounded-xl">
                  <p className="font-bold">Intro</p>
                  <p className="mt-1  rounded-md p-2 text-gray-700 break-all whitespace-pre-wrap w-full max-w-full">
                    {(
                      profiledate?.store_description ||
                      "No introduction available."
                    ).trim()}
                  </p>
                </div>
              </div>

              <div className="w-full md:w-[30%]">
                <div className="space-y-5">
                  <p className="flex gap-2 items-center">
                    <span>
                      <TiLocation className="text-xl text-gray-400" />
                    </span>
                    {profiledate?.location || "------"}
                  </p>
                  <p className="flex gap-2 items-center">
                    <span>
                      <FaMobile className="text-xl text-gray-400" />
                    </span>
                    {profiledate?.mobile_number || "------"}
                  </p>

                  <p className="flex gap-2 items-center">
                    <span>
                      <FaMessage className="text-xl text-gray-400" />
                    </span>
                    {profiledate?.email || "------"}
                  </p>

                  <p className="flex gap-2 items-center">
                    <span>
                      <TbWorldSearch className="text-xl text-gray-400" />
                    </span>
                    {profiledate?.website || "------"}
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-10">
              <div className="flex gap-4 lg:gap-10">
                {tabslist.map((res, i) => (
                  <button
                    key={i}
                    onClick={() => setTabs(res.id)}
                    className={`flex-1 lg:flex-none lg:w-[180px] border-b-[3px] text-start text-base md:text-xl font-semibold py-2 transition duration-200 ${
                      res.id === tabs
                        ? "border-[#095228] text-[#095228]"
                        : "border-[#ccc] text-gray-500"
                    }`}
                  >
                    {res.name}
                  </button>
                ))}
              </div>

              {tabs === 1 ? (
                <div>
                  <PostList profiledate={profiledate} />
                </div>
              ) : tabs === 2 ? (
                <div>
                  <EditProfile profiledate={profiledate} sellerId={sellerId} />
                </div>
              ) : 
                tabs === 3 ? (
                  <div>
                    <ShopCardList profiledate={profiledate} />
                  </div>
                
                
              ) : null}
            </div>
          </div>
        </main>
      </main>
    </div>
  );
};

export default Buyer;
